/**
 * [Insider+] Last-visited iframe-path persistence helpers.
 */

import { INSIDER_PLUS_LAST_PATH } from '../../constants/sessionStorage';
import {
  retrieveFromSessionStorage,
  storeInSessionStorage,
  removeFromSessionStorage,
} from './sessionStorageHelper';

const MAX_PATH_LENGTH = 2048;

// Reject absolute URLs, protocol-relative URLs, and anything that could
// resolve outside INSIDER_PLUS_BASE_URL when concatenated into the iframe src.
export const isSafeInsiderPlusPath = (value) => {
  if (typeof value !== 'string') return false;
  if (value.length === 0 || value.length > MAX_PATH_LENGTH) return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (value.includes('://')) return false;
  if (value.includes('\\')) return false;
  return true;
};

export const getStoredInsiderPlusPath = () => {
  const stored = retrieveFromSessionStorage(INSIDER_PLUS_LAST_PATH);
  return isSafeInsiderPlusPath(stored) ? stored : null;
};

export const storeInsiderPlusPath = (path) => {
  if (!isSafeInsiderPlusPath(path)) return;
  if (retrieveFromSessionStorage(INSIDER_PLUS_LAST_PATH) === path) return;
  storeInSessionStorage(INSIDER_PLUS_LAST_PATH, path);
};

export const clearInsiderPlusPath = () => {
  removeFromSessionStorage(INSIDER_PLUS_LAST_PATH);
};
